import React from 'react';
import { FaTimes } from 'react-icons/fa';

/**
 * ImagePreviewModal Component
 * 
 * A full-screen image preview modal with close functionality and zoom controls.
 * Displays images in a centered overlay with a close button.
 * 
 * @param {string} imageUrl - URL of the image to display
 * @param {Function} onClose - Function to call when modal should be closed
 * @returns {JSX.Element} Image preview modal component
 */
const ImagePreviewModal = ({ imageUrl, onClose }) => {
  if (!imageUrl) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80"
      onClick={onClose}
      style={{ cursor: 'zoom-out' }}
    >
      <div className="relative" onClick={e => e.stopPropagation()}>
        <img 
          src={imageUrl} 
          alt="Preview" 
          className="max-w-[90vw] max-h-[80vh] rounded-2xl shadow-2xl border-4 border-white" 
        />
        <button
          onClick={onClose}
          className="absolute top-2 right-2 bg-black bg-opacity-80 rounded-full p-2"
          style={{ zIndex: 10 }}
        >
          <FaTimes size={24} className="text-gray-100" />
        </button>
      </div>
    </div>
  );
};

export default ImagePreviewModal;
